module.exports = __webpack_public_path__ + "static/media/isdoctorplan-obgyn3.74533dd3.png";